import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { PopupRef } from '@local/ui-infra';
import { CustomKeyboardEvent, KeyboardService } from '@shared/services/keyboard.service';
import { isEnterKey, KeyName } from '@local/ts-infra';
import { HierarchyItem } from '../../models/hierarchyItem';
import { PopupHierarchyData } from '../../models/popupHierarchyData';
@Component({
  selector: 'hierarchy-subordinate-items',
  templateUrl: './hierarchy-subordinate-items.component.html',
  styleUrls: ['./hierarchy-subordinate-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HierarchySubordinateItemsComponent implements OnInit, OnDestroy {
  subordinateItems: HierarchyItem[];
  scrollHeight: string;
  selectedIndex: number = 0;
  private keyHandlerId: string;

  constructor(private ref: PopupRef<HierarchySubordinateItemsComponent, PopupHierarchyData>, private keyboardService: KeyboardService) {
    this.keyHandlerId = this.keyboardService.registerKeyHandler((keys: Array<KeyName>, event) => this.handleKeys(keys, event), 7);
  }
  ngOnDestroy(): void {
    this.keyboardService.unregisterKeyHandler(this.keyHandlerId);
  }

  ngOnInit(): void {
    this.subordinateItems = this.ref.data.items;
    this.scrollHeight = `${this.calcScrollHeight()}px`;
  }

  onSelectItem(selectedItem: HierarchyItem, index: number): void {
    this.ref.data.selectedItem = selectedItem;
    this.ref.data.selectedItem.index = index;
    this.ref.destroy();
  }

  calcScrollHeight(): number {
    const maxHeightScroll = 196;
    if (this.subordinateItems.length > 6) {
      return maxHeightScroll;
    }
    const itemHeight = 32;
    const marginToScroll = 4;
    return this.subordinateItems.length * itemHeight + marginToScroll;
  }

  private handleKeys(keys: Array<KeyName>, event: CustomKeyboardEvent) {
    switch (keys[0]) {
      case 'escape':
        this.ref.destroy();
        event.stopPropagation();
        return;

      case 'ArrowDown':
        if (this.selectedIndex + 1 < this.subordinateItems?.length) {
          this.selectedIndex++;
        }
        event.stopPropagation();
        return;

      case 'ArrowUp':
        if (this.selectedIndex > 0) {
          this.selectedIndex--;
        }
        event.stopPropagation();
        return;
    }
    if (isEnterKey(keys[0])) {
      if (!this.subordinateItems) return;
      this.onSelectItem(this.subordinateItems[this.selectedIndex], this.selectedIndex);
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    this.ref.destroy();
  }
}
